<template>
  <v-container fluid class=" pa-0" v-if="story">
    <!--BLOG CONTENT-->
    <v-container class=" fill-height">
      <v-row justify="start" align="start">
        <v-col cols="12" class="text-left content-blog">
          <vue-markdown>{{story.content}}</vue-markdown>
        </v-col>
      </v-row>
    </v-container>
    <!--/BLOG CONTENT-->

  </v-container>
</template>

<script>
import VueMarkdown from "vue-markdown";
// 1. Require the Storyblok client
import StoryblokClient from "storyblok-js-client";

// 2. Set your token
const token = "vNbkVTgCgnArqEk6TG7LQwtt";

// 3. Initialize the client with the preview token so we can access our API easily
// from your space dashboard at https://app.storyblok.com
let storyapi = new StoryblokClient({
  accessToken: token
});

export default {
  name: "BlogDetail",
  components: {
    "vue-markdown": VueMarkdown
  },
  props: ["blok"],
  data() {
    return {
      msg: "",
      story: null,
      url: null
    };
  },
  created() {
    this.url = window.location.href;
    // 4. Initialize the Storyblok Client Bridge to allow us to subscribe to events
    // from the editor itself.
    window.storyblok.init({
      accessToken: token
    });
    window.storyblok.on("change", () => {
      this.getstory("draft");
    });
    window.storyblok.pingEditor(() => {
      if (window.storyblok.isInEditor()) {
        // draft will be loaded if embeded in app.storyblok.com
        this.getstory("draft");
      } else {
        // published versions will be loaded outside of app.storyblok.com
        // so make sure to published your entries - otherwise this will be a 404
        this.getstory("published");
      }
    });
  },
  methods: {
    getstory(version) {
      storyapi
        .get(
          `cdn/stories/en/legal/${this.$route.params.name}`,
          {
            version: version
          }
        )
        .then(response => {
          if (response) {
            this.story = response.data.story.content;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    
  }
};
</script>
